import { inject } from '../../../../../common/container/inject';
import { ILearningRootService, LearningRootServiceToken } from '../../../../../service/LearningRootService';
import { IGetUserLearningDataByProjectArg } from '../../../../../service/report/interface/IGetUserLearningDataByProject';
import { IFullStudyReportDomain } from "./IFullStudyReportDomain";

export class FullStudyReportDomain implements IFullStudyReportDomain {
  constructor(
    protected learningRootService = inject<ILearningRootService>(LearningRootServiceToken)
  ) {}

  downloadReport = (arg) => this.learningRootService.report.getUserLearningDataByProject(arg);
  downloadEmployeesReport = (arg: IGetUserLearningDataByProjectArg) => this.learningRootService.report.getUserLearningDataByEmployee(arg);
}
